import { Divider, Typography } from "antd";
import React, { useState } from "react";
import VendorList from "./VendorList";

const { Title } = Typography;

const VendorManagement = () => {
    const isMobile = window.innerWidth < 768;

    return (
        <div style={{ padding: "24px 0" }}>
            <Title level={2}>{isMobile ? "Vendedores" : "Lista de vendedores"}</Title>
            <Divider />
            <VendorList />
        </div>
    );
};

export default VendorManagement;
